// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_wrapper__vcv42","noResultSuggest":"search_noResultSuggest__0tRVB","searchTabs":"search_searchTabs__LLHoN"};